import {
	Popover,
	PopoverDescription,
	PopoverDisclosure,
	PopoverProvider,
	usePopoverStore
} from '@ariakit/react'
import { useLocation, useOutletContext } from 'react-router'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { AnnotationDotsIcon, DownloadCloud02Icon } from '@/components/ui/icons'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { ImagesSortControls } from '@/features/photoset/components/images-sort-controls'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'

export const StepHeroControls = ({
	hideSortControls = false,
	hidePhotographerNotes = false,
	hideZipButton = false
}: {
	hideSortControls?: boolean
	hidePhotographerNotes?: boolean
	hideZipButton?: boolean
}) => {
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const location = useLocation()

	const photosetQuery = useGetPhotoset(
		{
			id: urlParams.id
		},
		{ enabled: false }
	)

	const photographerNotesPopover = usePopoverStore()

	return (
		<div className='flex items-center gap-4'>
			{!hideSortControls && (
				<ImagesSortControls
					isReadonlyOrderBy={location.pathname.includes('allocation')}
				/>
			)}

			{!(hidePhotographerNotes && hideZipButton) && (
				<div className='flex items-center gap-2'>
					{!hidePhotographerNotes &&
						photosetQuery.data?.assignment.photographer_notes && (
							<PopoverProvider
								placement='bottom-end'
								store={photographerNotesPopover}
							>
								<PopoverDisclosure
									render={
										<ButtonLegacy
											className='px-3 aria-expanded:border-primary-300 aria-expanded:shadow-[0_0_0_4px_var(--color-primary-200)]'
											size='sm'
											type='button'
											variant='secondary'
										>
											<AnnotationDotsIcon />
											Photographer notes
										</ButtonLegacy>
									}
								/>
								<Popover
									className='z-(--z-modal) h-[180px] w-[400px] overflow-hidden whitespace-pre-line rounded-lg border border-neutral-200 bg-neutral-white shadow-md'
									gutter={4}
									portal
								>
									<ScrollArea
										scrollbar={<Scrollbar />}
										style={{ height: '100%' }}
									>
										<PopoverDescription className='p-4 text-neutral-900'>
											{
												photosetQuery.data.assignment
													.photographer_notes
											}
										</PopoverDescription>
									</ScrollArea>
								</Popover>
							</PopoverProvider>
						)}

					{!hideZipButton && photosetQuery.data?.zip_url && (
						<ButtonLinkLegacy
							shape='square'
							to={photosetQuery.data.zip_url}
							variant='secondary'
						>
							<DownloadCloud02Icon />
						</ButtonLinkLegacy>
					)}
				</div>
			)}
		</div>
	)
}
